import * as React from 'react';

import { AnalyticsContextProps } from './types';

export const AnalyticsContext = React.createContext<AnalyticsContextProps>({
  record: () => null,
});

export const useAnalyticsContext = () => React.useContext(AnalyticsContext);
